import { Teaser as t } from '@xprog/prensa/types'
import { LayoutProviderDefaults } from '@xprog/prensa'
import { TeaserRelated } from './TeaserRelated'
const T = LayoutProviderDefaults.teasers

export const TeaserHeadlineSm: t.TeaserProps = {
  ...T.TeaserHeadlineSm,
  css: {
    p: '$0',
    mb: '$6',
    textAlign: 'center',
    width: '100%',
    '.TeaserImage': {
      display: 'none'
    },
    '.TeaserRelated': {
      'div.Teaser': {
        mb: '$4',
      },
      'div.TeaserTitle': {
        'p.TeaserTitleText': {
          fontSize: '16px',
          lineHeight: '19px',
          letterSpacing: '0.2px'
        },
      },
    },
    '.TeaserSubtitle': {
      align: ['column', 'center', 'top'],
      mb: '$4',
      maxWidth: '980px'
    },
    '.TeaserSubtitleText': {
      color: 'black',
      fontSize: '18px',
      lineHeight: '22px',
      fontWeight: 400,
      width: '100%'
    },
    '.TeaserSubject': {
      align: ['column', 'center', 'top'],
      mb: '$4'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserTitle': {
      mb: '$4',
      maxWidth: '980px'
    },
    '.TeaserTitleText': {
      color: 'black',
      fontSize: '26px',
      lineHeight: '30px',
      letterSpacing: '0.2px',
      fontWeight: 600,
      width: '100%'
    },
    '.TeaserWrap': {
      align: ['column', 'center', 'top']
    }
  },
  className: 'TeaserHeadlineSm',
  relatedLayout: TeaserRelated,
  subjectColor: 'brandPrimary500',
  subjectTextVariant: 'subject-default',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-default',
  titleVariant: 'newstitle-3xl',
}